import React from 'react';
import { Text, View, ViewStyle, StyleSheet } from 'react-native';
import theme from '../../common/theme';
import { useTheme } from '../../hooks/useTheme';
import IconButton from '../Button/IconButton';

export interface NotificationProps {
  error?: boolean;
  info?: boolean;
  warning?: boolean;
  message: string;
  success?: boolean;
  onClose?: () => void;
  containerStyle?: ViewStyle;
}

interface MessageProps {
  text: string;
  error?: boolean;
  success?: boolean;
  info?: boolean;
}

const Message: React.FC<MessageProps> = ({ text, error, success, info }) => {
  const { colors } = useTheme();
  const textColor = error || success || info ? colors.white : colors.text;
  return <Text style={[styles.messageText, { color: textColor }]}>{text}</Text>;
};

interface CloseButtonProps {
  onPress?: () => void;
  error?: boolean;
  success?: boolean;
  info?: boolean;
}

const CloseButton: React.FC<CloseButtonProps> = ({
  onPress,
  error,
  success,
  info,
}) => {
  const { colors } = useTheme();
  const iconColor = error || success || info ? colors.white : colors.text;
  return (
    <IconButton
      icon="times-circle"
      onPress={onPress}
      testID="closeNotification"
      iconStyle={{ color: iconColor }}
      iconSize={20}
    />
  );
};

const Notification: React.FC<NotificationProps> = ({
  message,
  onClose,
  containerStyle,
  error,
  success,
  info,
}: NotificationProps) => {
  const { colors } = useTheme();
  const backgroundColor = error
    ? colors.red
    : success
    ? colors.green
    : info
    ? colors.secondary
    : colors.elevation1;

  return (
    <View style={[styles.container, { backgroundColor }, containerStyle]}>
      <Message text={message} error={error} success={success} info={info} />
      <CloseButton
        onPress={onClose}
        error={error}
        success={success}
        info={info}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 50,
    alignItems: 'center',
    paddingHorizontal: theme.padding.large,
  },
  messageText: {
    flex: 1,
    textAlign: 'center',
    letterSpacing: -0.5,
  },
});

export default Notification;
